import { ScissorKanban } from '@/components/blocks/ScissorKanban';
import { useTasksStore } from '@/stores/tasksStore';

export function ScissorPage() {
  const tasks = useTasksStore(s => s.tasks);

  // Helper to format a Date as YYYY-MM-DD in local time
  const toLocalDateString = (d: Date) => {
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  };

  // Map activities to the TaskItem format needed by ScissorKanban
  const scissorTasks = tasks.map(t => ({
    id: t.id,
    title: t.title,
    duration: t.estimatedDuration || 30,
    day: t.scheduledStart ? toLocalDateString(new Date(t.scheduledStart)) : 'Unscheduled',
    is_splittable: true,
  }));

  return (
    <div className="flex h-full w-full flex-col overflow-hidden">
      <div className="border-b p-4">
        <h2 className="text-xl font-semibold">Activity Splitting (Scissor Mode)</h2>
        <p className="text-muted-foreground mt-1 text-sm">
          Use the scissor tool to visually halve activities and manage their lineage.
        </p>
      </div>
      <div className="flex-1 overflow-auto">
        <ScissorKanban initialTasks={scissorTasks} />
      </div>
    </div>
  );
}
